import { route as ziggyRoute } from 'ziggy-js';
import { Ziggy } from '../ziggy';

/**
 * Laravel route helper for Inertia/React components.
 * Uses Ziggy to generate URLs from named routes.
 *
 * @example
 * import { route } from '@/utils/route';
 *
 * // Simple route
 * route('orders.index')
 *
 * // Route with parameters
 * route('orders.show', { pedido: 123 })
 *
 * // Route with query params
 * route('products.index', { cat: 'verduleria' })
 */
export function route(
  name: string,
  params?: Record<string, any> | any,
  absolute: boolean = false
): string {
  return ziggyRoute(name, params, absolute, Ziggy);
}
